import { Record } from 'immutable';

export default class EmailRecord extends Record({
  subject: undefined,
  body: undefined,
}) {
}
